import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClienteTable } from "./ClienteTable";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { clientesStartLoad, clienteClearActive } from "../../../actions";
import { PageHeaderUi } from "../../ui/PageHeaderUi";
import { ClienteScreen } from "./ClienteScreen";

export const ClienteListScreen = ({ handleOpenForm }) => {
  const dispatch = useDispatch();
  const { clientes, loading } = useSelector((state) => state.cliente);
  const handleActualizar = () => {
    dispatch(clientesStartLoad());
  };
  return (
    <PageHeaderUi
      title="Clientes"
      subTitle="Listado"
      extra={[
        <ButtonUi
          typeUi={TipoButtonConstants.Actualizar}
          onClick={handleActualizar}
          key="Actualizar"
        />,
        <ButtonUi
          typeUi={TipoButtonConstants.Nuevo}
          onClick={handleOpenForm}
          key="Nuevo"
        />,
      ]}
    >
      <ClienteTable
        data={clientes}
        loading={loading}
        handleOpenForm={handleOpenForm}
      />
    </PageHeaderUi>
  );
};
export const ClienteList = () => {
  const dispatch = useDispatch();
  const [visibleForm, setVisibleForm] = useState(false);
  const handleOpenForm = () => setVisibleForm(true);
  const handleCloseForm = () => {
    setVisibleForm(false);
    dispatch(clienteClearActive());
  };
  useEffect(() => {
    dispatch(clientesStartLoad());
  }, []);

  if (visibleForm) {
    return <ClienteScreen handleCloseForm={handleCloseForm} />;
  } else {
    return <ClienteListScreen handleOpenForm={handleOpenForm} />;
  }
};

export default ClienteList;
